import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=3b34e35e&scoped=true&"
import script from "./Module.vue?vue&type=script&lang=js&"
export * from "./Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34e35e",
  null
  
)

component.options.__file = "Module.vue"
export default component.exports